var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.$style.burger,on:{"click":function($event){return _vm.setPageIsMenu(!_vm.pageIsMenu)}}},[_c('button',{class:[_vm.$style.button, _vm.pageIsMenu && _vm.$style.buttonOpen]},[_c('div',{class:[_vm.$style.wrapper, _vm.pageIsMenu && _vm.$style.wrapperOpen]})])])
}
var staticRenderFns = []

export { render, staticRenderFns }